import { getPermissionsManager } from './service'

export default {
  install(vue, store) {
    vue.prototype.$permissions = getPermissionsManager(store, vue.prototype.$permissions)
  },
}
